import type {
  GroupToRoleMapping,
  SamlIdentityProvider,
} from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  upsertGroupMappingFlow,
  type UpsertGroupMappingState,
} from './upsertGroupMappingFlow';

interface UpsertGroupMappingPanelProps {
  editMode: boolean;
  groupMapping: GroupToRoleMapping;
  saml: SamlIdentityProvider | undefined;
  onSave: (group: UpsertGroupMappingState) => Promise<void>;
  onAbort: () => void;
}

export function UpsertGroupMappingPanel(props: UpsertGroupMappingPanelProps) {
  const save = async (state: UpsertGroupMappingState) => {
    await props.onSave(state);
    return true;
  };

  return (
    <Wizard<UpsertGroupMappingState>
      onAbort={props.onAbort}
      onFinish={save}
      hideBackArrow={true}
      flow={[upsertGroupMappingFlow]}
      initialState={{
        editMode: props.editMode,
        groupMapping: props.groupMapping,
        saml: props.saml,
      }}
      title={
        props.groupMapping.groupName ? 'Edit Permissions' : 'New Group Mapping'
      }
    />
  );
}
